import speechBubbleSVG from '../assets/img/speechBubble.svg';
import easyLanguagePNG from '../assets/img/easyLanguage.png';
import simpleLanguageSVG from '../assets/img/simpleLanguage.svg';

window.VAE = window.VAE || {};

VAE.Language = (function () {
  'use strict';

  let subscriptionActive = false;
  let languageCardSetters = {};
  let uiControlSetters = {};

  const LANGUAGE_OPTIONS = [
    { value: 'de', text: 'Deutsch' },
    { value: 'en', text: 'English' },
    { value: 'fr', text: 'Französisch' },
    { value: 'it', text: 'Italienisch' },
    { value: 'es', text: 'Spanisch' },
    { value: 'nl', text: 'Niederländisch' },
    { value: 'pl', text: 'Polnisch' },
    { value: 'pt', text: 'Portugiesisch' },
    { value: 'sv', text: 'Schwedisch' },
    { value: 'fi', text: 'Finnisch' },
    { value: 'da', text: 'Dänisch' },
    { value: 'el', text: 'Griechisch' },
    { value: 'cs', text: 'Tschechisch' },
    { value: 'hu', text: 'Ungarisch' },
    { value: 'ro', text: 'Rumänisch' }
  ];

  const easyLanguageProfile = {
    profileKey: 'easyLanguage',
    title: 'Leichte Sprache',
    description: 'Sehr leicht verständlich',
    icon: `<img src="${easyLanguagePNG}" alt="Leichte Sprache" />`,
    isActive: false,
    onClick: (profileKey) => {
      console.log(`VAE.Language: Easy Language profile clicked: ${profileKey}`);
      toggleLanguageProfile(profileKey);
    }
  };

  const simpleLanguageProfile = {
    profileKey: 'simpleLanguage',
    title: 'Einfache Sprache',
    description: 'Klar & gut lesbar',
    icon: simpleLanguageSVG,
    isActive: false,
    onClick: (profileKey) => {
      console.log(`VAE.Language: Simple Language profile clicked: ${profileKey}`);
      toggleLanguageProfile(profileKey);
    }
  };

  function initStateManager() {
    if (subscriptionActive) return;
    console.log('VAE.Language: Initializing state manager integration');
    if (typeof VAE.StateManager === 'undefined') {
      console.error('VAE.Language: StateManager not available yet, will retry');
      setTimeout(initStateManager, 100);
      return;
    }
    VAE.StateManager.subscribe('language', handleStateUpdate);
    subscriptionActive = true;
  }

  function changeLanguage(language) {
    console.log(`VAE.Language: Changing language to ${language}`);
    VAE.StateManager.updateState('language', { language: language });
  }

  function toggleLanguageProfile(profileKey) {
    const currentState = getCurrentState();
    let newState = {};
    
    if (profileKey === 'easyLanguage') {
        newState.easyLanguageEnabled = !currentState.easyLanguageEnabled;
    } else if (profileKey === 'simpleLanguage') {
        newState.simpleLanguageEnabled = !currentState.simpleLanguageEnabled;
    }
    
    if (Object.keys(newState).length > 0) {
        VAE.StateManager.updateState('language', newState);
    }
  }

  function renderSectionContent(container) {
    if (!container) {
      console.warn('VAE.Language: Container element not provided for tab content');
      return;
    }

    container.innerHTML = '';
    languageCardSetters = {};
    uiControlSetters = {};

    try {
      const currentState = VAE.StateManager.getState('language');
      
      console.log('VAE.Language: Rendering tab content with state:', currentState);

      const sectionTitleElement = document.querySelector('.vae-section-divider h3:has(.vae-language-icon)');
         
      const languageDropdownResult = VAE.SharedUI.createDropdown({
        label: 'Sprache',
        icon: speechBubbleSVG,
        id: 'vae-language-select',
        options: LANGUAGE_OPTIONS,
        initialValue: currentState?.language || 'de',
        onChange: changeLanguage
      });
      const languageDropdownContainer = languageDropdownResult.container;
      uiControlSetters.language = languageDropdownResult.setValue;
      
      if (sectionTitleElement) {
        const titleWrapper = document.createElement('div');
        titleWrapper.className = 'vae-section-title-with-dropdown';
        
        const sectionDivider = sectionTitleElement.parentNode;
        
        sectionDivider.replaceChild(titleWrapper, sectionTitleElement);
        
        titleWrapper.appendChild(sectionTitleElement);
        
        const labelContainer = languageDropdownContainer.querySelector('.vae-label-container');
        if (labelContainer) {
          labelContainer.remove();
        }
        
        const selectWrapper = languageDropdownContainer.querySelector('.vae-select-wrapper');
        if (selectWrapper) {
          titleWrapper.appendChild(selectWrapper);
          selectWrapper.classList.add('vae-title-dropdown-wrapper');
        } else {
          const selectElement = languageDropdownContainer.querySelector('select');
          if (selectElement) {
            const newSelectWrapper = document.createElement('div');
            newSelectWrapper.className = 'vae-select-wrapper vae-title-dropdown-wrapper';
            newSelectWrapper.appendChild(selectElement);
            titleWrapper.appendChild(newSelectWrapper);
          } else {
            titleWrapper.appendChild(languageDropdownContainer);
            languageDropdownContainer.classList.add('vae-title-dropdown');
          }
        }
      } else {
        container.appendChild(languageDropdownContainer);
        console.warn('VAE.Language: Could not find section title element, adding dropdown to container instead');
      }
    

      const profileCardContainer = document.createElement('div');
      profileCardContainer.className = 'vae-language-profiles vae-profile-row';
      
      const easyLangCardResult = VAE.SharedUI.createProfileCard({
        ...easyLanguageProfile,
        isActive: currentState?.easyLanguageEnabled || false
      });
      const simpleLangCardResult = VAE.SharedUI.createProfileCard({
        ...simpleLanguageProfile,
        isActive: currentState?.simpleLanguageEnabled || false
      });
      
      languageCardSetters.easyLanguage = easyLangCardResult.setActive;
      languageCardSetters.simpleLanguage = simpleLangCardResult.setActive;
      
      profileCardContainer.appendChild(easyLangCardResult.card);
      profileCardContainer.appendChild(simpleLangCardResult.card);

      container.appendChild(profileCardContainer);
      
      console.log('VAE.Language: Tab content rendered successfully');
    } catch (e) {
      console.error('VAE.Language: Error rendering tab content:', e);
      container.appendChild(document.createTextNode('Error loading language settings. Please try refreshing the page.'));
    }
  }

  function handleStateUpdate(newState) {
    console.log('VAE.Language: Handling state update', newState);
    
    try {
      if (uiControlSetters.language && newState && newState.language) {
        uiControlSetters.language(newState.language);
      }
      
      if (languageCardSetters.easyLanguage) {
         languageCardSetters.easyLanguage(!!newState?.easyLanguageEnabled);
      }
      
      if (languageCardSetters.simpleLanguage) {
         languageCardSetters.simpleLanguage(!!newState?.simpleLanguageEnabled);
      }
      
    } catch (e) {
      console.error('VAE.Language: Error updating UI with state:', e);
    }
  }

  function getCurrentState() {
    try {
        const stateManagerValues = VAE.StateManager.getState('language');
        if (stateManagerValues) {
            return { ...stateManagerValues };
        }
    } catch (e) {
        console.error('VAE.Language: Error getting current state from StateManager:', e);
    }
    return {
      easyLanguageEnabled: false,
      simpleLanguageEnabled: false,
      language: 'de'
    };
  }
  
  function _init() {
    console.log('VAE.Language: Initializing module');
    
    function checkStateManager() {
      if (typeof VAE.StateManager !== 'undefined') {
        console.log('VAE.Language: State manager found, initializing connection');
        initStateManager();
      } else {
        console.log('VAE.Language: Waiting for state manager');
        setTimeout(checkStateManager, 50);
      }
    }
      
    checkStateManager();
    return true;
  }

  _init();

  return {
    renderSectionContent,
    getCurrentState
  };
})();